const requisitions = {
  err_requisition_not_found: {
    message:
      "Requisition doesn't exist or user doesn't have permission to view.",
  },
  err_requisition_already_closed: {
    message: 'Requisition is already closed.',
  },
  err_requisition_already_archived: {
    message: 'Requisition is already archived.',
  },
  err_permission_denied: {
    message: 'You do not have permission to perform this action.',
  },
  err_invalid_status: {
    message: 'Invalid requisition status for this action.',
  },
  err_requisition_has_active_jobs: {
    message: 'Cannot close requisition with active jobs.',
  },
  err_invalid_rejection_reason: {
    message: 'Please provide a valid rejection reason.',
  },
  err_requisition_create_failed: {
    message: 'Req creation failed. Try again later',
  },
  err_requisition_update_failed: {
    message: 'Req update failed. Try again later',
  },
  err_group_not_found: {
    message: 'Req update failed. Req group does not exist.',
  },
  err_requisition_associated: {
    message:
      'Requisition is filled. Remove the offer/hire to re-open this req.',
  },
  err_failed_to_reopen_requisition: {
    message: 'Requisition reopen failed. Try again later.',
  },
  err_failed_to_close_requisition: {
    message: 'Unable to close the requisition. Try again later.',
  },
  err_failed_to_toggle_confidential: {
    message: 'Unable to mark requisition as confidential. Try again later.',
  },
  err_failed_to_associate_job: {
    message: 'Unable to associate the job. Try again later.',
  },
  err_failed_to_update_recruiter: {
    message: 'Unable to update recruitment partner. Try again later.',
  },
  err_failed_to_archive_requisition: {
    message: 'Requisition archiving failed. Try again later.',
  },
  err_failed_to_open_requisition: {
    message: 'Requisition opening failed. Try again later.',
  },
  err_invalid_state_transition: {
    message: 'Req update failed. Try again later.',
  },
  err_missing_permission_for_confidential: {
    message: 'Req update failed. No access to edit confidential reqs',
  },
  err_missing_permission_for_recruiter: {
    message: "Recruitment partner access isn't available for this user",
  },
  err_missing_permission_for_hiring_manager: {
    message: "Hiring manager access isn't available for this user",
  },
  err_recruiter_not_found: {
    message:
      'Invalid user assigned as recruitment partner. Try again with a different one.',
  },
  err_hiring_manager_not_found: {
    message:
      'Invalid user assigned as hiring manager. Try again with a different one.',
  },
  err_job_not_found: {
    message: 'Invalid job association. Try again with a different one.',
  },
  err_job_is_closed_or_archived: {
    message: 'Unable to associate with a closed or archived job',
  },
  err_failed_to_trigger_reapproval: {
    message: 'Req update failed. X is mandatory',
  },
  err_requisition_already_associated: {
    message: 'Req is already in use. Try again with a different one.',
  },
  err_requisition_not_eligible: {
    message: 'Invalid req association. Try again with a different one.',
  },
  err_requisition_not_eligible_for_reapproval: {
    message: 'Req update failed. Try again later.',
  },
  err_cannot_change_headcount: {
    message:
      'Req update failed. Headcount cannot be changed once req is approved.',
  },
  err_requisition_associated_with_job: {
    message:
      'Invalid req association. Req is already associated with a different job.',
  },
  err_failed_to_add_requisitions: {
    message: 'Req association failed. Try again later.',
  },
  err_failed_to_remove_requisitions: {
    message: 'Req removal failed. Try again later.',
  },
  err_requisition_is_filled: {
    message: 'Req removal failed. Req is already associated with a candidate.',
  },
  err_requisition_is_mandatory: {
    message: 'Job creation failed. Req is mandatory.',
  },
  err_requisition_code_required: {
    message: 'Offer creation failed. Req is mandatory.',
  },
  err_cannot_remove_requisition: {
    message: 'Req removal failed. Req is already associated with a candidate.',
  },
  err_requisition_fill_failed: {
    message: 'Associated req was not filled. Try again later.',
  },
  err_requisition_reopen_failed: {
    message: 'Associated req was not reopened. Try again later.',
  },
  err_requisition_association_destroy_failed: {
    message: 'Associated req was not removed. Try again later.',
  },
  err_ats_offer_already_created: {
    message: 'Offer creation failed. Candidate already has an offer.',
  },
  err_application_already_associated_with_requisition: {
    message: 'Req association failed. Candidate already has a req associated.',
  },
  err_no_requisition_association_found: {
    message: 'Req removal failed. Candidate does not have a req associated.',
  },
  err_failed_to_remove_requisition: {
    message: 'Req removal failed. Try again later.',
  },
  err_application_not_in_hired_stage: {
    message:
      'Attempting to remove requisition from application not in hired stage.',
  },
  err_no_offer_stage_found: {
    message: 'Req removal failed. No offer stage detected.',
  },
  err_requisition_associated_different_job: {
    message:
      'Req association failed. Req is already associated with a different job.',
  },
  err_requisition_association_failed: {
    message: 'Req association failed. Try again later.',
  },
  err_target_start_date_must_be_gte_target_hire_date: {
    message: 'Target start date must be later than target hire date',
  },
  err_maximum_salary_must_be_greater_than_minimum_salary: {
    message: 'Maximum salary must be more than the minimum salary',
  },
  err_role_name_is_missing: {
    message:
      'Req creation failed. Role name is mandatory. / Req update failed. Role name is mandatory.',
  },
  err_employment_type_is_missing: {
    message:
      'Req creation failed. Employment type is mandatory. / Req update failed. Employment type is mandatory.',
  },
  err_requisition_type_is_missing: {
    message:
      'Req creation failed. Requisition type is mandatory. / Req update failed. Requisition type is mandatory.',
  },
  err_ats_department_id_is_missing: {
    message:
      'Req creation failed. Department is mandatory. / Req update failed. Department is mandatory.',
  },
  err_requisition_offices_attributes_is_missing: {
    message:
      'Req creation failed. Office is mandatory. / Req update failed. Office is mandatory.',
  },
  err_head_count_must_be_gteq_2: {
    message:
      'Req creation failed. Headcount must be atleast two. / Req update failed. Headcount must be atleast two.',
  },
  err_head_count_must_be_lteq_50: {
    message:
      'Req creation failed. Headcount cannot be more than 50. / Req update failed. Headcount cannot be more than 50.',
  },
  err_employment_type_must_be_included_in: {
    message:
      'Req creation failed. Employment type is invalid. / Req update failed. Employment type is invalid.',
  },
  err_requisition_type_must_be_included_in: {
    message:
      'Req creation failed. Requisition type is invalid. / Req update failed. Requisition type is invalid.',
  },
  err_rejection_reason_max_size_255: {
    message:
      'Req approval rejection reason is too long. It must be less than 255 characters',
  },
  err_note_max_size_500: {
    message: 'Note is too long. It must be less than 500 characters.',
  },
  err_sort_key_must_be_included_in: {
    message: 'Invalid sort. Refresh and try again.',
  },
  err_sort_order_must_be_included_in: {
    message: 'Invalid sort. Refresh and try again.',
  },
  err_group_id_is_missing: {
    message:
      'Req creation failed. Req group ID is mandatory. / Req update failed. Req group ID is mandatory.',
  },
  err_ats_job_id_is_missing: {
    message:
      'Req creation failed. Job ID is mandatory. / Req update failed. Job ID is mandatory.',
  },
  err_confidential_is_missing: {
    message:
      'Req creation failed. Req must be marked as confidential / Req update failed. Req must be marked as confidential.',
  },
  err_token_not_unique: {
    message:
      'A field with this name already exists. Try again with a different name.',
  },
  // Fired when an approval step's reviewer source is empty on the requisition —
  // a rel_user ("Users") field with no one selected, or a missing Recruitment
  // Partner.
  err_approval_reviewer_field_empty: {
    message:
      'A reviewer field required by the approval template is empty. Please fill it in (e.g. the "Users" field or Recruitment partner) before sending for approval.',
  },
  err_approval_reviewer_inactive: {
    message:
      'A reviewer required by the approval template is deactivated or deleted. Please update the reviewer field or Recruitment partner and try again.',
  },
  // BE appends the offending token after a colon (e.g.
  // "err_invalid_offer_sections_token:offer.salery"); getErrorKey strips it.
  err_invalid_offer_sections_token: {
    message:
      'An offer section contains an invalid token. Please check the tokens used in the offer sections and try again.',
  },
};

export default requisitions;
